import React from 'react';
import { localise } from '../../../../services/lang/lang';
import ScrollablePanel from './ScrollablePanel';
const RemoteSubmissionNotesPanel = ({ remoteSubmission }) => (React.createElement(ScrollablePanel, { title: localise('TENANT_NOTES'), condition: !!remoteSubmission.description, fallbackText: localise('NONE_ADDED'), "data-testid": "remote_submission_panel__tenant_notes" }, remoteSubmission.description));
export default RemoteSubmissionNotesPanel;
